import React from "react";

import { StyledLabel, StyledToggleInput, StyledToggleSwitch } from "./style";

const ToggleSwitch = ({ value, onChange }) => (
  <StyledToggleSwitch>
    <StyledToggleInput
      type="checkbox"
      id="switch"
      isChecked={value}
      onChange={onChange}
    />
    <StyledLabel htmlFor="switch">Toggle</StyledLabel>
  </StyledToggleSwitch>
);

export default ToggleSwitch;
